import { createSlice } from "@reduxjs/toolkit"
import { notification } from "antd"

// http client
import client from "../../lib/client"
import { supplyAccountNotesUrl, supplyAccountNoteUrl, supplyAccountNoteByIdUrl, supplyAccountNotesExportCsvUrl } from "../../lib/endpoints"
import { createFilterUrl } from "../../functions/objectFunctions/createFilterUrl"
import { createRansackParams } from "../../functions/objectFunctions/createRansackParams"
import { setAccountAlert } from "./supplyAccountsSlice"

export const supplyAccountNotesSlice = createSlice({
    name: "supplyAccountNotes",
    initialState: {
        supplyAccountNote: {},
        supplyAccountNotes: [],
        total: 0,
        pagination: { current: 1, pageSize: 10 },
        loading: false,
        filters: {},
        sort: { column: "name", direction: "asc" },
    },
    reducers: {
        setSupplyAccountNote: (state, action) => {
            state.supplyAccountNote = action.payload
        },
        setSupplyAccountNotes: (state, action) => {
            state.total = action.payload.total
            state.supplyAccountNotes = action.payload.s_acc_notes
        },
        setPagination: (state, action) => {
            state.pagination = action.payload
        },
        setLoading: (state, action) => {
            state.loading = action.payload
        },
        setFilters: (state, action) => {
            state.filters = action.payload
        },
        setSort: (state, action) => {
            state.sort = action.payload
        },
        deleteSupplyAccountNote: (state, action) => {
            state.supplyAccountNotes = state.supplyAccountNotes.filter((note) => note.id !== action.payload)
            state.total = state.total - 1
        },
    },
})

export const { setSupplyAccountNote, setSupplyAccountNotes, setPagination, setLoading, setFilters, setSort } = supplyAccountNotesSlice.actions

export function fetchSupplyAccountNote(clientId, supplyAccountId, noteId) {
    return async (dispatch, getState) => {
        dispatch(setLoading(true))

        client.get(`${supplyAccountNoteByIdUrl(clientId, supplyAccountId, noteId)}`).then((response) => {
            dispatch(setSupplyAccountNote(response.data))
            dispatch(setLoading(false))
        })
    }
}

export function fetchSupplyAccountNotes(clientId, supplyAccountId) {
    return async (dispatch, getState) => {
        dispatch(setLoading(true))

        client.get(`${supplyAccountNotesUrl(clientId, supplyAccountId)}`).then((response) => {
            // dispatch(setPagination(pagination))
            dispatch(setSupplyAccountNotes(response.data))
            dispatch(setLoading(false))
        })
    }
}

export function submitSupplyAccountNote(values, supplyAccountNoteId, resetTable = false) {
    return async (dispatch, getState) => {
        if (supplyAccountNoteId) {
            const response = await client.patch(supplyAccountNoteUrl(supplyAccountNoteId), { supply_account_note: values })
            if(resetTable){
                dispatch(setSupplyAccountNotes(response.data.message))
            }
            return response
        } 
        else {
            const response = await client.post(supplyAccountNoteUrl(supplyAccountNoteId), { supply_account_note: values })
            return response
        }
    }
}

export function modifySupplyAlert(newAlert) {
    return async (dispatch, getState) => {
        dispatch(setAccountAlert(newAlert))
    }
}

export function generateCsv(clientId, accountId) {
    return async (dispatch, getState) => {
        client.get(`${supplyAccountNotesExportCsvUrl(clientId, accountId)}?connection_id=${getState().app.uid}`)
    }
}


export const selectSupplyAccountNote = (state) => state.supplyAccountNotes.supplyAccountNote
export const selectSupplyAccountNotes = (state) => state.supplyAccountNotes.supplyAccountNotes
export const selectTotal = (state) => state.supplyAccountNotes.total
export const selectPagination = (state) => state.supplyAccountNotes.pagination
export const selectLoading = (state) => state.supplyAccountNotes.loading
export const selectFilters = (state) => state.supplyAccountNotes.filters
export const selectSort = (state) => state.supplyAccountNotes.sort

export default supplyAccountNotesSlice.reducer
